<template>
  <div id="major-table" class="bg-white shadow rounded-lg p-4 sm:p-6 xl:p-8 mb-3" v-if="items">
    <h3 class="text-xl leading-none font-bold text-gray-900 mb-10">{{ title }}</h3>
    <div class="block w-full overflow-x-auto">
      <table class="items-center w-full bg-transparent border-collapse">
        <thead>
        <tr>
          <th
            class="px-4 bg-gray-50 text-gray-700 align-middle py-3 text-xs font-semibold text-left uppercase border-l-0 border-r-0 whitespace-nowrap"
          >{{ subtitle }}
          </th>
          <th
            class="px-4 bg-gray-50 text-gray-700 align-middle py-3 text-xs font-semibold text-left uppercase border-l-0 border-r-0 whitespace-nowrap"
          >Amount
          </th>
          <th
            class="px-4 bg-gray-50 text-gray-700 align-middle py-3 text-xs font-semibold text-left uppercase border-l-0 border-r-0 whitespace-nowrap min-w-140-px"
          ></th>
          <th
            class="px-4 bg-gray-50 text-gray-700 align-middle py-3 text-xs font-semibold text-left uppercase border-l-0 border-r-0 whitespace-nowrap min-w-140-px"
          ></th>
        </tr>
        </thead>
        <tbody class="divide-y divide-gray-100">
        <tr class="text-gray-500" v-for="(item, key) in items">
          <th class="border-t-0 px-4 align-middle text-sm font-normal whitespace-nowrap p-4 text-left">{{ item.name }}
          </th>
          <td class="border-t-0 px-4 align-middle text-xs font-medium text-gray-900 whitespace-nowrap p-4">
            {{ item.total }}
          </td>
          <td class="border-t-0 px-4 align-middle text-xs whitespace-nowrap p-4">
            <div class="flex items-center">
              <span class="mr-2 text-xs font-medium">{{ percentage(item) }}%</span>
              <div class="relative w-full">
                <div class="w-full bg-gray-200 rounded-sm h-2">
                  <div class="bg-orange-300 h-2 rounded-sm" :style="'width: '+percentage(item)+'%'"></div>
                </div>
              </div>
            </div>
          </td>
          <td class="flex justify-end border-t-0 px-4 align-middle text-xs whitespace-nowrap p-4">
            <icon name="download" class="block w-3 h-3 fill-gray-400 cursor-pointer" @click="exportDataDetails(item)"/>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import Icon from '@/Shared/Icon'
export default {
  components:{Icon},
  props: {
    items: {
      type: Object,
    },
    total: Number,
    title: String,
    subtitle: String,
  },
  methods: {
    percentage(item) {
      return (item.total / this.total * 100).toFixed(1)
    },
    exportDataDetails(item){
      this.$emit('exportDataDetails', item);
    }
  },
}
</script>
<style>
#major-table{
  height: 500px;
  overflow-y: scroll;
}
</style>
